import { Stack, Box, Paper, Button, CircularProgress } from "@mui/material";
import TitlePage from "@components/atoms/TitlePage/TitlePage";
import TitlePaper from "@components/atoms/TitlePaper/TitlePaper";
import InputText from "@components/atoms/InputText/InputText";
import ErrorAlert from "@components/atoms/ErrorAlert/ErrorAlert";
import { ICreateClientUI } from "src/types/organisms";
import { useFormValidate } from "@utils/hooks";
const CreateClientUI = ({
  register,
  onSubmit,
  isLoading,
  errorMessage,
  showError,
  errors,
  closeError,
  handleCancelClick
}: ICreateClientUI) => {
  const {
    validateField
  } = useFormValidate();
  const classes = {
    rootPaper: {
      width: 1,
      padding: "24px",
      marginTop: 3
    }
  };
  return <>
      <TitlePage title="Crear cliente" subtitle="Construye la base de datos de tus clientes con facilidad. Aquí puedes iniciar la creación de un nuevo cliente." />
      <Paper elevation={12} sx={classes.rootPaper} onKeyDown={e => e.key.toLowerCase() === "enter" ? onSubmit() : null}>
        <TitlePaper title="Información del cliente" subtitle="Por favor, ingresa la información del cliente a continuación. Asegúrate de proporcionar detalles de contacto precisos para una gestión efectiva." />
        <Stack component="form" direction={"row"} justifyContent={"space-between"} alignItems={"flex-start"} marginTop={3} flexWrap={"wrap"} noValidate>
          <Box marginBottom={2} width={0.49}>
            <InputText label={"Nombre"} name={"fullName"} placeholder={"Ingresa el nombre"} register={register("fullName", {
            required: true
          })} helperText={validateField(errors?.fullName)} disabled={isLoading} />
          </Box>
          <Box marginBottom={2} width={0.49}>
            <InputText label={"Número de documento"} name={"identification"} placeholder={"Ingresa número de documento"} register={register("identification", {
            required: true,
            valueAsNumber: true
          })} helperText={validateField(errors?.identification)} disabled={isLoading} />
          </Box>
          <Box marginBottom={2} width={0.49}>
            <InputText label={"Teléfono"} name={"phone"} placeholder={"Ingresa número de teléfono"} register={register("phone", {
            required: true,
            valueAsNumber: true
          })} helperText={validateField(errors?.phone)} disabled={isLoading} />
          </Box>
          <Box marginBottom={2} width={0.49}>
            <InputText label={"Correo electrónico"} name={"email"} placeholder={"Ingresa correo electrónico"} register={register("email", {
            pattern: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/
          })} helperText={validateField(errors?.email)} disabled={isLoading} />
          </Box>
          <Box marginBottom={2} width={0.49}>
            <InputText label={"Cupo (opcional)"} name={"moneyCapAmount"} placeholder={"Ingresa el cupo del cliente"} register={register("moneyCapAmount", {
            valueAsNumber: true
          })} disabled={isLoading} type="number" />
          </Box>
        </Stack>
      </Paper>
      <Stack direction={"row"} justifyContent={"flex-end"} marginTop={3} spacing={3}>
        <Button color="secondary" size="large" disabled={isLoading} onClick={handleCancelClick}>
          Cancelar
        </Button>
        <Button type="submit" size="large" onClick={isLoading ? () => null : onSubmit} endIcon={isLoading && <CircularProgress thickness={3} size={20} sx={{
        color: "white"
      }} />}>
          {isLoading ? "Creando cliente" : "Crear cliente"}
        </Button>
      </Stack>
      <ErrorAlert open={showError} onClose={closeError} message={errorMessage} />
    </>;
};
export default CreateClientUI;